// src/components/register/RegistrationWizard/Steps/EducationalForms/MastersForm.js
import React, { useState, useEffect } from "react";
import SearchDropdown from "../../../../Usables/SearchDropdown";
import Dropdown from "../../../../Usables/Dropdown/Dropdown";
import MultiSelectDropdown from "../../../../Usables/MultiSelectDropdown";
import FloatInputField from "../../../../Usables/FloatInputField";
import CollegeList from "../../../../userForms/FormsData/Colleges";
import YearOfStudy from "../../../../userForms/FormsData/Year";
import FutureOpportunityTypesList from "../../../../userForms/FormsData/FutureFields";
import SchoolBoard from "../../../../options/schoolBoard";
import DegreeList from "../../../../options/MasterDegree";
import BachelorsExam from "../../../../userForms/Bachelors/BachelorsExam";

const MastersForm = ({ onChange, data = {} }) => {
  // Form state
  const [college, setCollege] = useState(data.collegename || "");
  const [collegeName, setCollegeName] = useState(data.collegename || "");
  const [year, setYear] = useState(data.collegeyear || "");
  const [tenthBoard, setTenthBoard] = useState(data.tenthBoard || "");
  const [twelthBoard, setTwelthBoard] = useState(data.twelthBoard || "");
  const [tenthPercentage, setTenthPercentage] = useState(data.tenthPercentage || "");
  const [twelthPercentage, setTwelthPercentage] = useState(data.twelthPercentage || "");
  const [tenthSchoolName, setTenthSchoolName] = useState(data.tenthschoolname || "");
  const [twelthSchoolName, setTwelthSchoolName] = useState(data.twelthschoolname || "");
  const [compensation, setCompensation] = useState(data.compensation || "");
  const [gpa, setGPA] = useState(data.gpa || "");
  const [currentdegree, setCurrentDegree] = useState(data.currentdegree || "");
  const [currentDegreeLabel, setCurrentDegreeLabel] = useState("");
  const [futuredegree, setFutureDegree] = useState(data.futuredegree || "");
  const [futureDegreeLabel, setFutureDegreeLabel] = useState("");
  const [futureOpportunityTypes, setFutureOpportunityTypes] = useState(
    data.futureOpportunityTypes ? JSON.parse(data.futureOpportunityTypes) : []
  );
  const [err, setErr] = useState(null);
  const [err2, setErr2] = useState(null);
  const [exams, setExams] = useState(data.exams ? JSON.parse(data.exams) : [
    {
      type: "text",
      id: 1,
      name: "",
      date: "",
      percentage: "",
      criteria: "100 %",
    },
  ]);

  // Update parent component whenever form data changes
  useEffect(() => {
    onChange({
      collegename: college,
      collegeyear: year,
      tenthBoard,
      twelthBoard,
      tenthPercentage,
      twelthPercentage,
      tenthschoolname: tenthSchoolName,
      twelthschoolname: twelthSchoolName,
      compensation,
      gpa,
      currentdegree,
      futuredegree,
      futureOpportunityTypes: JSON.stringify(getValuesArray(futureOpportunityTypes)),
      exams: JSON.stringify(exams)
    });
  }, [
    college, year, tenthBoard, twelthBoard, tenthPercentage, twelthPercentage,
    tenthSchoolName, twelthSchoolName, compensation, gpa, currentdegree,
    futuredegree, futureOpportunityTypes, exams, onChange
  ]);

  // Helper function to extract values from multi-select options
  const getValuesArray = (options) => {
    if (!options || options.length === 0) return [];
    return options.map(option => option.value);
  };

  const handleCollege = (value, label) => {
    setCollegeName(label);
    setCollege(value);
  };

  const handleYear = (e) => {
    setYear(e.value);
  };

  const handleTenthBoard = (e) => {
    setTenthBoard(e.value);
  };

  const handleTwelthBoard = (e) => {
    setTwelthBoard(e.value);
  };

  const handleTenthPercentage = (event) => {
    const value = event.target.value;
    if (value !== "" && isNaN(value)) {
      setErr("Please enter a valid number between 0 and 100");
    } else if (value < 0 || value > 100) {
      setErr("Please enter a number between 0 and 100");
    } else {
      setErr(null);
    }
    setTenthPercentage(value);
  };

  const handleTwelthPercentage = (event) => {
    const value = event.target.value;
    if (value !== "" && isNaN(value)) {
      setErr2("Please enter a valid number between 0 and 100");
    } else if (value < 0 || value > 100) {
      setErr2("Please enter a number between 0 and 100");
    } else {
      setErr2(null);
    }
    setTwelthPercentage(value);
  };

  const handleTenthSchoolName = (event) => {
    setTenthSchoolName(event.target.value);
  };

  const handleTwelthSchoolName = (event) => {
    setTwelthSchoolName(event.target.value);
  };

  const handleCompensation = (event) => {
    setCompensation(event.target.value);
  };

  const handleGPA = (event) => {
    setGPA(event.target.value);
  };

  const handleCurrentDegree = (value, label) => {
    setCurrentDegreeLabel(label);
    setCurrentDegree(value);
  };

  const handleFutureDegree = (value, label) => {
    setFutureDegreeLabel(label);
    setFutureDegree(value);
  };

  const handleFutureOppsTypes = (options) => {
    setFutureOpportunityTypes(options);
  };

  return (
    <div className="educational-form-content">
      <div className="form-section">
        <SearchDropdown
          options={CollegeList}
          onSelect={handleCollege}
          placeholderInput="Search your College"
          placeholderDropdown="College Name"
          value={{ value: college, label: collegeName }}
        />
      </div>
      
      <div className="form-section">
        <Dropdown
          name="currentYear"
          value={year}
          options={YearOfStudy}
          placeHolder="Current Year of Study"
          onChange={handleYear}
        />
      </div>
      
      <div className="form-section">
        <SearchDropdown
          options={DegreeList}
          onSelect={handleCurrentDegree}
          placeholderInput="Search your degree"
          placeholderDropdown="Degree Pursuing"
          value={{ value: currentdegree, label: currentDegreeLabel }}
        />
      </div>
      
      <div className="form-section">
        <SearchDropdown
          options={DegreeList}
          onSelect={handleFutureDegree}
          placeholderInput="Search your degree"
          placeholderDropdown="Future Degree"
          value={{ value: futuredegree, label: futureDegreeLabel }}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="expectedCompensation"
          placeHolder="Expected Compensation (INR Monthly)"
          handleInput={handleCompensation}
          inputVal={compensation}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="gpa"
          placeHolder="Current GPA (On a scale of 10)"
          handleInput={handleGPA}
          inputVal={gpa}
        />
      </div>
      
      <div className="form-section">
        <Dropdown
          name="TenthBoard"
          value={tenthBoard}
          options={SchoolBoard}
          placeHolder="10th Board"
          onChange={handleTenthBoard}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="TenthPercentage"
          placeHolder="10th Percentage"
          handleInput={handleTenthPercentage}
          err={err}
          inputVal={tenthPercentage}
        />
      </div>
      
      <div className="form-section">
        <Dropdown
          name="TwelthBoard"
          value={twelthBoard}
          options={SchoolBoard}
          placeHolder="12th Board"
          onChange={handleTwelthBoard}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="TwelthPercentage"
          placeHolder="12th Percentage"
          handleInput={handleTwelthPercentage}
          err={err2}
          inputVal={twelthPercentage}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="TenthSchoolName"
          placeHolder="10th School Name"
          handleInput={handleTenthSchoolName}
          inputVal={tenthSchoolName}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="SchoolName"
          placeHolder="12th School Name"
          handleInput={handleTwelthSchoolName}
          inputVal={twelthSchoolName}
        />
      </div>
      
      <div className="form-section exams-section">
        <BachelorsExam exams={exams} setExams={setExams} />
      </div>
      
      <div className="form-section">
        <MultiSelectDropdown
          options={FutureOpportunityTypesList}
          onSelect={handleFutureOppsTypes}
          value={futureOpportunityTypes}
          placeholderDropdown="Opportunity types interested in"
          placeholderInput="Search for interested fields"
          showSearchBar={true}
          showSelectAll={false}
        />
      </div>
    </div>
  );
};

export default MastersForm;